<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      border
      :data="tableData"
      :disable-hover="true"
      style="width: 100.1%"
    ></Table>
    <br />
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableCoverageReport",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      companyIds: [],
      interval: 0,
      statisticsDate: "",
      columns: [
        {
          title: this.$t("reservedInstance.coverage.customer"),
          key: "companyName"
        },
        {
          title: this.$t("reservedInstance.coverage.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("reservedInstance.coverage.accountId"),
          key: "accountIdStr"
        },
        {
          title: this.$t("reservedInstance.coverage.EC2"),
          key: "ec2PercentStr"
        },
        {
          title: this.$t("reservedInstance.coverage.RDS"),
          key: "rdsPercentStr"
        },
        {
          title: this.$t("reservedInstance.coverage.Redshift"),
          key: "redshiftPercentStr"
        },
        {
          title: this.$t("reservedInstance.coverage.ElastiCache"),
          key: "cachePercentStr"
        },
        {
          title: this.$t("reservedInstance.coverage.Opensearch"),
          key: "openSearchPercentStr"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  mounted: function() {
    tableDataVue.getData();
  },
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      // 获取搜索内容
      eventBus.$on("companyIds", function(companyIds) {
        tableDataVue.companyIds = companyIds;
      });
      eventBus.$on("accountIds", function(val) {
        tableDataVue.accountIds = val;
      });
      eventBus.$on("accountName", function(val) {
        tableDataVue.accountName = val;
      });
      eventBus.$on("statisticsDate", function(val) {
        tableDataVue.statisticsDate = val;
      });
      eventBus.$on("interval", function(interval) {
        tableDataVue.interval = interval;
      });
      const time = new Date().getTime() - (2 * 24 * 60 * 60 * 1000);
      this.$api.awsReservationStatistics
        .pageReport({
          interval: !this.interval ? 7 : this.interval,
          statisticsType: 1,
          accountName: tableDataVue.accountName,
          companyIds: !this.companyIds ? [1] : this.companyIds,
          accountIds: this.accountIds,
          statisticsDate:
            !this.statisticsDate ? new Date(time).getFullYear() +
              "-" +
              (new Date(time).getMonth() + 1 < 10
                ? "0" + Number(new Date(time).getMonth() + 1)
                : Number(new Date(time).getMonth() + 1)) +
              "-" +
              (new Date(time).getDate() < 10
                ? "0" + Number(new Date(time).getDate())
                : Number(new Date(time).getDate()))
              : this.statisticsDate,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style>
.red {
  background-color: #d22828 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.green {
  background-color: #187 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/reserved_instance/coverage_report/TableCoverageReport.vue